import axios from "axios";
import getBackendUrl from "../../environment/BackendService";
import { useAuth } from "../hooks/AuthContext";
import { useLoader } from "../hooks/LoaderContext";
import { useRef } from "react";

export const axios_helper_no_header = async (method, url, data, params) => {
  try {
    const response = await axios({
      method: method,
      url: `${getBackendUrl()}${url}`,
      data: data,
      params: params,
    });

    return response?.data;
  } catch (error) {
    console.error("Request failed:", error);
    return Promise.reject(error.response);
  }
};

export const useAxios = () => {
  const { AuthHeaders } = useAuth();
  const { setIsLoaderEnabled } = useLoader();
  const cancelTokenSource = useRef(null);

  // Function to cancel the ongoing request
  const cancelRequest = () => {
    if (cancelTokenSource.current) {
      cancelTokenSource.current.cancel("Request was canceled.");
      setIsLoaderEnabled(false);
    }
  };

  const axios_helper_no_header = async (
    method,
    url,
    data,
    params,
    responseType = ""
  ) => {
    cancelTokenSource.current = axios.CancelToken.source();
    const config = {
      method: method,
      url: `${getBackendUrl()}${url}`,
      data: data,
      params: params,
      headers: AuthHeaders,
      cancelToken: cancelTokenSource.current.token,
      ...(responseType === "blob" && { responseType: "blob" }),
    };
    setIsLoaderEnabled(true);
    try {
      const response = await axios(config);

      return responseType === "blob" ? response : response?.data;
    } catch (error) {
      console.error("Request failed:", error);
      return Promise.reject(error.response);
    }finally {
      setIsLoaderEnabled(false);
    }
  };
  return { axios_helper_no_header, cancelRequest };
};